import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../types';
import { LocalAnnotationCommandState } from './types';

const selectAnnotation = (state: AppState) => state.annotation;

/** A selector that returns whether or not the annotations queue is currently being processed. */
export const selectAnnotationIsQueueProcessing = createSelector(selectAnnotation, state => state.isQueueProcessing);

export const selectLocalAnnotationCommands = createSelector(selectAnnotation, state => state.localCommands);

/** A selector factory which returns a selector that will find a single command by its command id. */
export const createLocalAnnotationCommandByCommandIdSelector = (commandId: string) =>
  createSelector(selectLocalAnnotationCommands, cmd => cmd.find(i => i.commandId === commandId));

/** A selector that returns a record where the key is an annotation id, and the value is an ordered list of commands associated with that annotation. */
export const selectLocalAnnotationCommandGroups = createSelector(selectLocalAnnotationCommands, commands => {
  return commands.reduce(
    (acc, val) => {
      const next = { ...acc };
      next[val.annotationId] = [...(next[val.annotationId] ?? []), val];
      return next;
    },
    {} as Record<string, LocalAnnotationCommandState[]>,
  );
});
